import { Injectable } from '@angular/core';
import { NgInject } from '@df/ng/ng-inject';
import { Client } from '@df/core/service/client';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { DfModalService } from '@df/ui/modal/df-modal.service';
import { ICmsBlock } from '@icms/core/resource/block/icms-block';
import { ICmsBlockResource } from '@icms/core/resource/block/icms-block.resource';
import { NICmsContentComponent } from '../../../core/content';
import { ICmsContentService } from '../../../core/content/icms-content.service';

@Injectable({ providedIn: 'root' })
export class ICmsModalService extends DfModalService {
    @NgInject(ICmsBlockResource)
    private iCmsBlockResource!: ICmsBlockResource;

    @NgInject(ICmsContentService)
    private iCmsContentService!: ICmsContentService;

    override async loadDependencies(
        modal: NDfModal.IConfig,
        variant?: string,
        options: NDfModal.IOpenOptions = {}
    ): Promise<ICmsBlock | void> {
        const meta = this.iCmsContentService.getComponentMetaByType(modal.component as NICmsContentComponent.ICmsComponentType<any>);
        if (!meta || !meta.block) {
            return;
        }
        return this.iCmsBlockResource.retrieve(
            {
                bareUrl: meta.block.url,
                variant,
                createOnError: options.createOnError || this.client.isCms
            },
            undefined
        );
    }

    getICmsModals() {
        return this.getAll().filter(i => this.isICmsModal(i));
    }

    protected override onCreateComponent(componentInstance: any, modal: NDfModal.IConfig, variant?: string) {
        componentInstance.modalConfig = <NDfModal.IModalConfig>modal;

        if (modal.type === 'cmsmodal') {
            (componentInstance as NICmsContentComponent.IComponent).variant = variant;
        }
    }

    /**
     * Modal is cms thing if the component it prints is cms one
     */
    private isICmsModal(modal: NDfModal.IConfig) {
        return this.iCmsContentService.getComponentMetaByType(modal.component as NICmsContentComponent.ICmsComponentType<any>);
    }
}
